import React from "react";
import RegistryPage from "../components/RegistryPage";
import { StatusBadge } from "../components/Badges";

const TYPES = ["rest_api","sql","postgres","mysql","mongodb","csv","email_smtp","sms","webhook","siem","ticketing","cloud_inventory","sso"];

export default function Integrations({ embedded }) {
  return (
    <RegistryPage
      title={embedded ? "" : "Integrations"}
      description={embedded ? "Legacy integration registry — declared systems not yet moved to a live connector." : "Connector framework for data systems, SIEM, ticketing, email, and SSO."}
      endpoint="/integrations"
      testIdPrefix="integrations"
      columns={[
        { key: "name", label: "Name" },
        { key: "integration_type", label: "Type", width: "140px" },
        { key: "status", label: "Status", width: "120px", render: (i) => <StatusBadge status={i.status} /> },
        { key: "last_sync_at", label: "Last sync", width: "140px", render: (i) => i.last_sync_at?.slice(0,10) || "—" },
      ]}
      fields={[
        { key: "name", label: "Name", required: true },
        { key: "integration_type", label: "Type", type: "select", options: TYPES, required: true },
        { key: "status", label: "Status", type: "select", options: ["inactive","active","error"] },
      ]}
      defaultItem={{ integration_type: "rest_api", status: "inactive", config: {} }}
    />
  );
}
